module.exports = "./af7ae505a9eed503f8b8e6982036873e.woff2";